<template>
  <div class="news" :class="{ vertical: vertical }" @click="$router.push({ name: 'newsId', params: { id: news.publicId } })">
    <div class="news-content image-content hide-small" :class="{ noImage: !news.imageUrl }">
      <div class="image" :style="{ 'background-image': `url(${news.imageUrl})` }" />
    </div>

    <div class="news-content info-content">
      <div class="date">{{ $utils.formatDate(news.publishedAt) }}</div>
      <div class="title" v-html="news.title" />
      <div class="new-content" v-html="news.resume" />
      <div class="read-more-content link-button">
        <div class="icon"></div>
        <div class="read-more">{{ $t('readMore') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: {
      type: Object,
      required: true,
    },

    vertical: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.news {
  height: 256px;
  width: calc(50% - 12px);
  min-width: calc(responsive.$layout-breakpoint-small / 2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px 12px 0;
  border-radius: 4px;
  overflow: hidden;
  background: colors.$unread-table-color;

  cursor: pointer;

  &:nth-child(2n) {
    margin: 0 0 12px 4px;
  }

  @media only screen and (max-width: responsive.$layout-breakpoint-extralarge) {
    width: 100%;
    margin-right: 0 !important;
  }

  .news-content {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    &.image-content {
      width: 256px;
      flex-shrink: 0;

      .image {
        margin: 0;
        height: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      &.noImage {
        width: 0;
        display: none;
      }
    }

    &.info-content {
      padding: 32px;
    }

    .date,
    .title {
      font-weight: 500;
    }

    .date {
      font-size: 11px;
      color: colors.$grey-color;
      margin: 0 0 12px;
    }

    .title {
      min-height: 30px;
      color: colors.$green-color;
      font-size: 20px;
      margin: 0 0 6px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
    }

    .read-more-content {
      position: absolute;
      bottom: 32px;
      left: 32px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 24px 0 0 0;
      font-weight: 500;

      .icon {
        width: 6px;
        height: 6px;
        border: 2px solid colors.$main-color;
        transform: rotate(-45deg);
        border-left: none;
        border-top: none;
        margin-right: 12px;
      }

      .read-more {
        text-decoration: underline;
      }

      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }

    .new-content {
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      font-size: 15px;
      overflow: hidden;
      word-break: break-word;
    }
  }

  &.vertical {
    flex-direction: column;
    height: unset;

    height: 458px;

    .image-content {
      height: 196px;
      width: 100%;
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .news {
    background: colors.$unread-table-color;
    border-radius: 4px;
    padding: 32px 32px 24px 32px;
    height: auto;
    min-width: 100%;
    box-sizing: border-box;

    flex-direction: column;

    padding: 0;

    .image-content {
      height: 186px;
      width: 100% !important;
    }

    .info-content {
      padding: 32px 32px 24px 32px !important;
    }

    .news-content {
      max-width: 100% !important;

      &:nth-child(2n) {
        border: none;
      }
    }
  }
}
</style>
